<template>
  <v-container class="text-center">
    <v-row justify="center">
      <v-col cols="12" md="6">
        <v-card class="pa-5" outlined>
          <h3>Data Import Progress</h3>
          <v-progress-circular
            v-if="isImporting"
            :indeterminate="!hasProgress"
            color="blue"
            size="100"
            width="15"
            :value="progressValue"
          >
            <span v-if="hasProgress">{{ progressValue }}%</span>
          </v-progress-circular>
          <v-icon v-else-if="isThereAnError" color="red" size="100">
            {{icons.mdiAlphaXCircle}}
          </v-icon>
          <v-icon v-else color="green" size="100">{{icons.mdiCheckCircle}}</v-icon>
          <p v-if="isImporting">{{ value }} total records processed</p>
          <p v-if="isImporting">{{ totalRecords }} total records to process</p>
          <p v-else>Total Data Imported: {{ value }}</p>
          <p v-if="isThereAnError">There was an error while importing</p>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mdiCheckCircle, mdiAlphaXCircle } from '@mdi/js';

export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    totalRecords: {
      type: Number,
      default: 0,
    },
    isImporting: {
      type: Boolean,
      default: false,
    },
    isThereAnError: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      importedInInterval: 0,
      totalImported: 0,
      importComplete: false,
      targetData: 2000,
      icons: {
        mdiCheckCircle,
        mdiAlphaXCircle,
      },
    };
  },
  computed: {
    hasProgress() {
      return this.totalRecords > 0;
    },
    progressValue() {
      if (!this.hasProgress) {
        return 0;
      }

      const progress = Math.round((this.value / this.totalRecords) * 100);
      return Math.min(Math.max(progress, 0), 100);
    },
  },
};
</script>

<style scoped>
.text-center {
  text-align: center;
}
</style>
